<template>
    <div class="list">

    <div class="auctionRegister">
        <h1 class="topTitle">出品登録一覧</h1>
        <!-- <button @click="test">test</button> -->
        <div class="container" >
            <div class="outer-menu">
                <input class="checkbox-toggle" v-model="isShowSerchBox" type="checkbox" />
                <div class="hamburger" :class="{ searchIcon: !isShowSerchBox}" @click="isShowSerchBox = !isShowSerchBox">
                    <div v-if="isShowSerchBox"></div>
                </div>
                <div class="menu">
                    <div class="searchArea">
                        <div class="searchBox">
                            <h2 class="itemTitle">検索</h2> 
                            <ul>
                                <li>
                                    <label for="itemName">カテゴリ:</label>
                                    <select class="sltBox" v-model="serchItem.category">
                                        <option value="" disabled selected hidden>選択してください</option>
                                        <option v-for="item in categoryList" :value="item.ID" :key="item.ID">
                                            {{ item.CATEGORY_NAME }}
                                        </option>
                                    </select>
                                </li>
                            <li>
                                <label for="itemName">商品名:</label>
                                <input type="text" placeholder="商品名" id="itemName" v-model="serchItem.name" tabindex="1"/>
                            </li>
                            
                            <li class="serchDateBox">
                                <label for="price">販売価格:</label>
                                <input class="searchDate" type="number" placeholder="販売価格（FROM）" id="price" v-model="serchItem.itemPriceStr" tabindex="2"/> ~ 
                                <input class="searchDate" type="number" placeholder="販売価格（TO）" v-model="serchItem.itemPriceEnd" tabindex="2"/>
                            </li>
                        </ul>
                        <div class="btnBox">
                            <button class="btn" @click="isShowSerchBox = !isShowSerchBox, clear()">クリア</button>
                            <button class="btn" @click="isShowSerchBox = !isShowSerchBox, serch()">検索</button>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="userBox">
                <div>
                    <div class="rightBox">
                        <button class="btn regist" @click="setAuction">新規出品登録</button>
                    </div>
                    <table class="selectUser">
                        <tr>
                            <td class="subTitle">設定ユーザー名</td>
                            <td class="subContent">
                                <select class="sltBox" v-model="setUserId" @change="getAuctionInfo">
                                    <option value="" disabled selected hidden>選択してください</option>
                                    <option v-for="item in userList" :value="item.USER_ID" :key="item.USER_ID">
                                        {{ item.USER_NAME }}
                                    </option>
                                </select>
                            </td>
                        </tr>
                        <tr v-show="!isDisabled">
                            <td class="subTitle">選択数</td>
                            <td class="subContent">
                                <span class="minText">【メルカリ：<span class="weight900">{{getSelectNum('m')}}</span>】</span>
                                <span class="minText">【在庫0：<span class="weight900">{{getSelectNumNonQty('m')}}</span>】</span>
                                <!-- <span class="minText">【ラクマ：<span class="weight900">{{getSelectNum('r')}}</span>】<br></span>
                                <span class="minText">【ヤフオク：<span class="weight900">{{getSelectNum('y')}}</span>】</span> -->
                                <!-- <span class="minText">【PAYPAY：<span class="weight900">{{getSelectNum('p')}}</span>】</span> -->
                            </td>
                            <td>
                                <button class="btn" style="line-height: 1;background-color: #0b5ed7;border-color: #0a58ca;" @click="allCheck">このページを全てチェックする</button>
                                <button class="btn" style="line-height: 1;background-color: #0b5ed7;border-color: #0a58ca; margin-top: 5px;" @click="allUnCheck">全てのチェックを外す</button>
                                <button v-if="allShow" class="btn" style="line-height: 1;background-color: #0b5ed7;border-color: #0a58ca; margin-top: 5px;" @click="showNonQty">在庫0のみ表示する</button>
                                <button v-if="!allShow" class="btn" style="line-height: 1;background-color: #0b5ed7;border-color: #0a58ca; margin-top: 5px;" @click="setAuction">全て表示する</button>
                            </td>
                        </tr>
                    </table>
                
                </div>
                <br>
                
            </div>
            <div class="btnBox subArea">
                <button class="btn repage" @click="modalOpen">出品時間設定</button>
                <button class="btn submit" @click="register" :disabled="isDisabled" >登録する</button>
            </div>
            <div class="item-wrap">
                <table class="itemTable">
                    <tr>
                        <th class="listTitle">
                            出品サイト
                        </th>
                        <!-- <th class="listTitle">
                            出品グループ
                        </th> -->
                        <!-- <th class="listTitle">
                            出品時間
                        </th> -->
                        
                        <th class="listTitle">
                            商品画像
                        </th>
                        <th class="listTitle">
                            商品名
                        </th>
                        <th class="listTitle">
                            カテゴリ
                        </th>
                        <th class="listTitle">
                            販売価格
                        </th>
                        <th class="listTitle">
                            在庫数
                        </th>
                        <th class="listTitle">
                            備考
                        </th>
                    </tr>
                    <tr v-for="(item , index) in getItems" :key="item.ITEM_ID" v-show="item.display && setUserId != ''">
                        <td class="listItem siteType">
                            <!-- {{isDisabled ||
                                (
                                    getSelectNum('m') >= maxItem ||
                                    getSelectNum('r') >= maxItem ||
                                    getSelectNum('y') >= maxItem 
                                )
                                &&
                                item.siteType.length != 4}} -->
                            <!-- <input type="checkbox" v-model="item.isAllSelected" :id="index + ((currentPage -1) *  perPage)+'_all'" @change="selectAll(index + ((currentPage -1) *  perPage))" 
                            :disabled="
                                isDisabled ||
                                (
                                    getSelectNum('m') >= maxItem ||
                                    getSelectNum('r') >= maxItem ||
                                    getSelectNum('y') >= maxItem 
                                )
                                &&
                                item.siteType.length != 4
                                " 
                            :checked="item.siteType.length == 4">
                            <label class="checkbox03" :for="index + ((currentPage -1) *  perPage)+'_all'">全選択</label> -->
                            
                            <input type="checkbox" v-model="item.siteType" :id="index + ((currentPage -1) *  perPage)+'_m'" value="m" @change="arrUp" 
                            
                            checked=true>
                            <label class="checkbox03" :for="index + ((currentPage -1) *  perPage)+'_m'">メルカリ</label>
                        
                            <!-- <input type="checkbox" v-model="item.siteType" :id="index + ((currentPage -1) *  perPage)+'_r'" value="r" @change="arrUp" 
                            :disabled="
                                isDisabled || 
                                (
                                    getSelectNum('r') >= maxItem 
                                ) &&
                                item.siteType.indexOf('r') == -1"  
                            checked=true>
                            <label class="checkbox03" :for="index + ((currentPage -1) *  perPage)+'_r'">ラクマ</label>
                        
                            <input type="checkbox" v-model="item.siteType" :id="index + ((currentPage -1) *  perPage)+'_y'" value="y" @change="arrUp" 
                            :disabled="
                                isDisabled || 
                                (
                                    getSelectNum('y') >= maxItem 
                                )&&
                                item.siteType.indexOf('y') == -1" 
                            checked=true>
                            <label class="checkbox03" :for="index + ((currentPage -1) *  perPage)+'_y'">ヤフオク</label> -->
                            
                            <!-- <input type="checkbox" v-model="item.siteType" :id="index + ((currentPage -1) *  perPage)+'_p'" value="p" @change="arrUp" 
                            :disabled="
                                isDisabled || 
                                (
                                item.STOCK_QUANITY <= 0) &&
                                item.siteType.indexOf('p') == -1" 
                            checked=true>
                            <label class="checkbox03" :for="index + ((currentPage -1) *  perPage)+'_p'">PAYPAY</label> -->
                        </td>
                        <!-- <td class="listItem center">
                            <select class="sltBox" v-model="item.group">
                                <option value="0">毎日出品する</option>
                                <option v-for="n in 7" :value="n" :key="n">
                                    {{ n }}グループで出品する
                                </option>
                            </select>
                        </td> -->
                        <td class="listItem center">
                            <img class="itemImg" :src="item.TMP_IMG">
                        </td>
                        <td class="listItem">
                            {{item.ITEM_TITLE}}
                        </td>
                        <td class="listItem">
                            {{ item.R_CATEGORY }}
                            {{getCategoryName(item.R_CATEGORY)}}
                        </td>
                        <td class="listItem">
                            {{item.ITEM_PRICE}}<p class="unit">円</p>
                        </td>
                        <td class="listItem">
                            {{item.STOCK_QUANITY}}<p class="unit">個</p>
                        </td>
                        <td class="listItem">
                            {{item.MEMO}}
                        </td>
                        
                    </tr>
                    
                </table>
                
                <div class="pdgTop10">
                    <vuejs-paginate
                    :page-count="getPaginateCount"
                    :prev-text="'<'"
                    :next-text="'>'"
                    :click-handler="paginateClickCallback"
                    :container-class="'pagination justify-content-center'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :first-last-button="true"
                    :first-button-text="'<<'"
                    :last-button-text="'>>'"
                    ></vuejs-paginate>
                </div>
                
            </div>

            <div class="overlay" v-show="modalFlg">
                    <div class="createModal">
                    <div class="swal2-popup swal2-modal swal2-show" style="display: grid;" >
                        <div class="createUser">
                            <div class="login_form_top">
                                <h1 class="title">出品・値引き時間設定</h1>
                            </div>
                            <div class="formBox">
                                <h2 id="userName" class="itemLabel">毎日出品</h2>
                                    <vue-timepicker
                                    format="HH"
                                    v-model="postItem[0]"
                                    placeholder="00"
                                    close-on-complete
                                    hide-clear-button
                                    ></vue-timepicker>
                                    <p class="unit">時(出品)</p><br>
                                    <vue-timepicker
                                        format="HH"
                                        v-model="downItem[0]"
                                        placeholder="00"
                                        close-on-complete
                                        hide-clear-button
                                        ></vue-timepicker>
                                        <p class="unit">時(値引き)</p>
                                <!-- <div v-for="n in 7" :value="n" :key="n">
                                    <h2 id="userName" class="itemLabel">グループ{{n}}</h2>
                                    <vue-timepicker
                                    format="HH"
                                    v-model="postItem[n]"
                                    placeholder="00"
                                    close-on-complete
                                    hide-clear-button
                                    ></vue-timepicker>
                                    <p class="unit">時(出品)</p><br>
                                    <vue-timepicker
                                        format="HH"
                                        v-model="downItem[n]"
                                        placeholder="00"
                                        close-on-complete
                                        hide-clear-button
                                        ></vue-timepicker>
                                        <p class="unit">時(値引き)</p>
                                </div> -->
                                
                                
                            <div class="btnBox">
                                <button class="btn repage"  @click="modalFlg = !modalFlg">キャンセル</button>
                                <button class="btn"  @click="setWgroup">更新</button>
                            </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            
        </div>
    </div>
    </div>
</template>
<script>
import {itemRepository} from '@/Repositories/itemRepository.js'
import {userRepository} from '@/Repositories/userRepository.js'
import {auctionRepository} from '@/Repositories/auctionRepository.js'
import {wgroupRepository} from '@/Repositories/wgroupRepository.js'
import {cApiRepsitory} from '@/Repositories/cApiRepsitory.js'
import VueJsPaginate from 'vuejs-paginate';
import Datepicker from 'vuejs-datepicker';

import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import {ja} from 'vuejs-datepicker/dist/locale';
export default {
    
  data() {
        return {
            /******************
             * Datepicker設定
            ******************/
            ja:ja,
            disabledDates:{
                from:new Date()
            },
            /******************
             * 表示フラグ
            ******************/
            isShowSerchBox:false,
            isDisabled:true,
            maxItem:0,
            modalFlg:false,
            allShow:false,
            /******************
             * ユーザー情報
            ******************/
            userInfo:{},
            userList:[],
            setUserId:'',
            tmpSiteType:null,
            /******************
             * 商品情報
            ******************/
            itemList:[{siteType:[],isAllSelected: false,}],
            tmpItemList:[{siteType:[],isAllSelected: false,}],
            /******************
             * 検索ボックス
            ******************/
            serchItem : {
                name:null,
                itemPrice:null,
                createDateStr:null,
                createDateEnd:null,
                category:null,
            },
            categoryList:[],
            postItem:[],
            downItem:[],
            /******************
             * ページング設定
            ******************/
            currentPage: 1,
            perPage: 20
        }
  },
    components: {
        "vuejs-paginate": VueJsPaginate,
        "vue-timepicker": VueTimepicker,
        Datepicker,
    },
  methods:{
    modalOpen(){
        this.getWgroup();
        this.modalFlg = !this.modalFlg;
        
    },
    getWgroup(){
        this.postItem = [];
        this.downItem = [];
        cApiRepsitory.methods.post({
            "type":'wgroup',
            "user_id":this.setUserId
        }).then(res=>{
            if(res.data.length == 0){
                while(true){
                    this.postItem.push('00');
                    this.downItem.push('00');
                    if(this.postItem.length >= 8)
                    break;
                }
            }else{
                for(var i=0; i<res.data.length; i++ ){
                    this.postItem[Number(res.data[i].GROUP_NM)] = res.data[i].SELL_TIME;
                    this.downItem[Number(res.data[i].GROUP_NM)] = res.data[i].DOWN_TIME;
                }
            }
            this.postItem.splice();

        })
        
        
    },
    setWgroup(){
        var item = [];
        // for(var i=0;i<this.postItem.length; i++){
        //     if(this.postItem[i] === undefined){
        //         this.postItem[i] = "00";
        //     }
        //     if(this.downItem[i] === undefined){
        //         this.downItem[i] = "00";
        //     }
        //     item.push({
        //         "USER_ID":this.setUserId,
        //         "GROUP_NM":i,
        //         "SELL_TIME":this.postItem[i],
        //         "DOWN_TIME":this.downItem[i]
        //     })
        // }

        item.push({
            "USER_ID":this.setUserId,
            "GROUP_NM":'0',
            "SELL_TIME":this.postItem[0],
            "DOWN_TIME":this.downItem[0]
        })
        wgroupRepository.methods.setAll(item)
        .then(res=>{
            this.$swal("更新しました", {
                        icon: "success",
                    })
        });
        this.modalFlg = false;
            
        
    },
      arrUp(){
        this.tmpItemList.splice();
      },
      getSelectNum(type){
        var selectedArr = this.itemList.filter(item=>{
            return item.siteType.indexOf(type) != -1;
        });
        return selectedArr.length;
      },
      getSelectNumNonQty(type){
        var selectedArr = this.itemList.filter(item=>{
            return item.siteType.indexOf(type) != -1 && item.STOCK_QUANITY == '0';
        });
        return selectedArr.length;
      },
      showNonQty(){
        this.tmpItemList = this.tmpItemList.filter(x=> x.STOCK_QUANITY == '0');
        this.allShow = false;
      },
      getMaxSelectNum(){
        var tmpArr = [];
        tmpArr.push(this.getSelectNum("m"));
        tmpArr.push(this.getSelectNum("r"));
        tmpArr.push(this.getSelectNum("y"));
        tmpArr.sort((a,b)=>{return b - a});
        return tmpArr[0];
        },
      selectAll(index){
          var arr = [];
          var selectedFlg = this.tmpItemList[index ].isAllSelected;
          if(selectedFlg){
               arr= ['m','r','y','p'];
          }
          this.tmpItemList[index ].siteType =arr;
          this.arrUp();
      },
      getCategory(){
        cApiRepsitory.methods.post({
            "user_id":this.userInfo.USER_ID,
            "type":'getCategory'
        }).then(res=>{
            this.categoryList = res.data;
        })
    },
    getCategoryName(id){
        var category = this.categoryList.find(x=> x.ID == id);
        if(category) return category.CATEGORY_NAME
        else return '';
    },
      serch(){
        let vm = this;
        var tmpItemList = [...vm.itemList];
        if(vm.serchItem.category){
            //名前フィルター
            tmpItemList = tmpItemList.filter(function(item) {
                return item.R_CATEGORY == vm.serchItem.category;
            });
        }
        
        if(vm.serchItem.name){
            //名前フィルター
            tmpItemList = tmpItemList.filter(function(item) {
                return item.ITEM_TITLE.match(vm.serchItem.name) != null
            })
        }
        if(vm.serchItem.itemPriceStr){
            //存在チェック
            tmpItemList = tmpItemList.filter(function(item) {
                return Number(item.ITEM_PRICE) >= Number(vm.serchItem.itemPriceStr);
            });
        }
        if(vm.serchItem.itemPriceEnd){
            //存在チェック
            tmpItemList = tmpItemList.filter(function(item) {
                return  Number(item.ITEM_PRICE) <= Number(vm.serchItem.itemPriceEnd) ;
            });
        }
        vm.tmpItemList = tmpItemList;
    },
    clear(){
        this.tmpItemList = this.itemList;
        console.log(this.tmpItemList);
        for(var i=0; i< this.tmpItemList.length; i++){
            this.tmpItemList[i].display =true;
        }
        this.serchItem ={};
    },
    paginateClickCallback (pageNum) {
        this.currentPage = Number(pageNum);
    },
    
    register(data){
        let vm = this;
           this.$functions.swAlert(vm, "warning", "出品登録します。")
           .then((btn) => {
            if (btn.isConfirmed) {
                var postData = [];
                for(var i =0; i < vm.tmpItemList.length; i++){
                    var putCount = 0;
                    if(vm.tmpItemList[i].siteType.length == 0){
                        putCount = -1;
                    }
                    postData.push({
                        USER_ID: vm.setUserId,
                        ITEM_ID: vm.tmpItemList[i].ITEM_ID,
                        PUT_COUNT:putCount,
                        SELL_GROUP:vm.tmpItemList[i].group,
                        IS_MERCARI:vm.tmpItemList[i].siteType.indexOf('m') != -1? 1:0,
                        IS_RAKUMA	:vm.tmpItemList[i].siteType.indexOf('r') != -1? 1:0,
                        IS_YAHOO:vm.tmpItemList[i].siteType.indexOf('y') != -1? 1:0,
                        IS_PAYPAY:vm.tmpItemList[i].siteType.indexOf('p') != -1? 1:0,
                    });
                }
                auctionRepository.methods.register(postData)
                .then(res=>{
                    this.$swal("登録しました", {
                        icon: "success",
                    }).then(()=>{
                        this.$router.go({path: this.$router.currentRoute.path, force: true})
                    });
                })
            }
        });
          
      },
      init(){
            let vm =this;
            vm.userInfo = vm.$functions.getSStorage('userInfo');
            userRepository.methods.getChild()
            .then(res=>{
                var data = res.data;
                for(var i=0; i< data.length; i++){
                    if(data[i].siteType) data[i].siteType = data[i].siteType.split(',');
                }
                
                vm.userList = data;
                vm.setUserId = vm.userList[0].USER_ID;
                vm.getAuctionInfo(vm.setUserId);
            })
            this.getCategory();
        },
        getAuctionInfo(){
            let vm =this;
            //最大出品数設定
            vm.maxItem  = vm.userInfo.MAX_SELE_NUM;
            auctionRepository.methods.getAll(vm.setUserId)
            .then(res=>{
                var data = res.data;
                vm.tmpSiteType = data;
                vm.tmpItemList = [...vm.itemList];
                
                vm.setSiteType();
                vm.tmpItemList = vm.tmpItemList.filter(item=>{
                    return item.display == true;
                })
            })
        },
        setSiteType(){
            let vm = this;
            var dItem = null;
            console.log(vm.tmpSiteType);
            console.log(vm.tmpItemList);
            var data = vm.tmpSiteType;
            vm.tmpItemList.filter((item, i, arr)=> {
                // console.log(item.ITEM_ID);
                if(data){
                    dItem = data.find(d=> d.ITEM_ID == item.ITEM_ID);
                }
                console.log(dItem);
                if(dItem){
                    arr[i].siteType = [];
                    if(dItem.IS_MERCARI == '1') arr[i].siteType.push('m');
                    if(dItem.IS_RAKUMA == '1') arr[i].siteType.push('r');
                    if(dItem.IS_YAHOO == '1') arr[i].siteType.push('y');
                    if(dItem.IS_PAYPAY == '1') arr[i].siteType.push('p');
                    arr[i].isAllSelected = arr[i].siteType.length == 4;
                    arr[i].siteType.length <= 0 ?arr[i].display = false : arr[i].display = true;
                    arr[i].group = dItem.SELL_GROUP == null? 0 :  dItem.SELL_GROUP;
                    arr[i].time = dItem.SELL_TIME == null? 0 :  dItem.SELL_TIME;
                }else{
                    
                    arr[i].isAllSelected = false;
                    arr[i].display = false;
                    arr[i].siteType = [];
                }
            })
        },
        setAuction(){
            let vm = this;
            vm.isDisabled = false;
            vm.allShow = true;
            vm.tmpItemList = [...vm.itemList];
                
            vm.setSiteType();
            vm.clear();
        },
        getAllItem(){
            let vm =this;
            itemRepository.methods.getAll()
            .then(res=>{
                vm.itemList = res.data;
                for(var i=0; i<vm.itemList.length; i++){
                    vm.itemList[i].siteType = [];
                    vm.itemList[i].display = true;
                    vm.itemList[i].gloup = 0;
                    vm.itemList[i].time = 0;
                }
                vm.init();
            })
        },
        returnPage(){
            let vm = this;
            vm.$router.back();
        },
        allUnCheck(){
            
            for(var item of this.tmpItemList){
                item.siteType = [];
            }
            this.tmpItemList.splice();
        },
        allCheck(){
            console.log(this.tmpItemList);
            let start = (this.currentPage - 1) * this.perPage;
            let end = this.currentPage * this.perPage;
            var items = this.tmpItemList.slice(start, end);
            for(var item of items){
                if(item.STOCK_QUANITY > 0){
                    if(!Array.isArray(item.siteType))item.siteType = [];
                    if(item.siteType.indexOf('m') == -1)
                    {
                        item.siteType.push('m');
                    }
                }
                
            }
            this.tmpItemList.splice();
        }
  },
  computed:{
        getPaginateCount: function () {
            return Math.ceil(this.tmpItemList.length / this.perPage);
        },
        getItems () {
            if(this.itemList.length == 0) return;
            let start = (this.currentPage - 1) * this.perPage;
            let end = this.currentPage * this.perPage;
            return this.tmpItemList.slice(start, end);
        }
    },
   created:async function(){
        let vm =this;
        await vm.getAllItem();

  },
  
}
</script>

<style lang="scss">
    @import "../style/auctionRegister.scss";
</style>
<style scoped>
.createModal{
    height: 70%;
    position: fixed;
    overflow: scroll;
}
.createModal::-webkit-scrollbar {  
  display: none; /*Google Chrome、Safari、Microsoft Edge対応のスクロールバー非表示コード*/
}
</style>